import { render } from "./ContactBox.vue?vue&type=template&id=4370cec9&scoped=true"
import script from "./ContactBox.vue?vue&type=script&lang=js"
export * from "./ContactBox.vue?vue&type=script&lang=js"

import "./ContactBox.vue?vue&type=style&index=0&id=4370cec9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4370cec9"]])

export default __exports__